import type { BlockchainNetwork } from "@/interfaces/blockchainNetwork";
import BlockchainNetworkCard from "./BlockchainNetworkCard";
import BlockchainNetworkEmpty from "./BlockchainNetworkEmpty";

interface Props {
  networks: BlockchainNetwork[];
  onCreate?: () => void;
  onView?: (network: BlockchainNetwork) => void;
  onEdit?: (network: BlockchainNetwork) => void;
  onRpc?: (network: BlockchainNetwork) => void;
  onDelete?: (network: BlockchainNetwork) => void;
  onToggleEnabled?: (network: BlockchainNetwork) => void;
  onToggleDeposits?: (network: BlockchainNetwork) => void;
  onToggleWithdrawals?: (network: BlockchainNetwork) => void;
}

const BlockchainNetworkGrid = ({
  networks,
  onCreate,
  onView,
  onEdit,
  onRpc,
  onDelete,
  onToggleEnabled,
  onToggleDeposits,
  onToggleWithdrawals,
}: Props) => {
  if (!networks.length) {
    return <BlockchainNetworkEmpty onCreate={onCreate} />;
  }

  return (
    <div className="grid gap-6 md:grid-cols-2 2xl:grid-cols-3">
      {networks.map((network) => (
        <BlockchainNetworkCard
          key={network.id}
          network={network}
          onView={onView}
          onEdit={onEdit}
          onRpc={onRpc}
          onDelete={onDelete}
          onToggleEnabled={onToggleEnabled}
          onToggleDeposits={onToggleDeposits}
          onToggleWithdrawals={onToggleWithdrawals}
        />
      ))}
    </div>
  );
};

export default BlockchainNetworkGrid;
